import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";

function NotFoundPage() {
	const navigate = useNavigate();

	const handleBackHome = () => {
		navigate("/");
	};

	return (
		<Result
			status="404"
			title="404"
			subTitle="Sorry, the page you visited does not exist."
			extra={
				<Button type="primary" onClick={handleBackHome}>
					Back Home
				</Button>
			}
		/>
	);
}

export default NotFoundPage;
